<script lang="ts">
  import Title from '$shared/atoms/Title/Title.svelte';
  import TextArea from '$shared/atoms/TextArea/TextArea.svelte';

  interface Props {
    title?: string;
    loading?: boolean;
    error?: string;
    feedback?: string;
    onevent?: (payload: { type: string; data: any }) => void;
  }

  let {
    title = '',
    loading = false,
    error = '',
    feedback = '',
    onevent
  }: Props = $props();
</script>

<div class="comp-atlas-feedback-popup">
  <div class="title"><Title type="h3">{title}</Title></div>
  {#if loading}
    <div class="loading">Loading...</div>
  {:else if error}
    <div class="error">{error}</div>
  {:else}
    <TextArea
      name="feedback"
      placeholder="Please provide your feedback here..."
      isFullHeight={true}
      value={feedback}
      oninput={(e) => {
        onevent?.({ type: 'feedbackChange', data: (e.target as HTMLTextAreaElement)?.value });
      }}
    />
  {/if}
</div>

<style>
  .comp-atlas-feedback-popup {
    padding: 24px;
    width: 100%;
    height: 100%;
  }
  .title {
    margin-bottom: 16px;
  }
</style>
